module.exports = __webpack_public_path__ + "static/media/kiss.c16bcc61.png";